/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  ChangeEvent,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Grid from '@material-ui/core/Grid';
import { BsTrash } from 'react-icons/bs';

import {
  TabWrapper,
  DrawerTabTitle,
  RadioDisponibilidadeWrapper,
  DisponibilidadeWrapper,
  SelectTurno,
  AddButton,
  ButtonAction,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';
import material_styles from '../../../drawer_styles/material_styles';
import { useToast } from '../../../../../../../hooks/toast';
import { useSimpleProduct } from '../../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';

import schedulesOptions from '../../../../../utils/schedulesOptions';

interface TurnoType {
  inicio: number;
  fim: number;
}

interface QtdTurnos {
  index: number;
}

const Disponibilidade: React.FC = () => {
  const [sempreDisponivel, setSempreDisponivel] = useState(true);
  const [qtdTurnos, setQtdTurnos] = useState<QtdTurnos[]>([]);
  const [days, setDays] = useState({
    domingo: false,
    segunda: false,
    terca: false,
    quarta: false,
    quinta: false,
    sexta: false,
    sabado: false,
  });
  const [btnDisable, setBtnDisable] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();

  const { addToast } = useToast();

  const { createDisponibilidade, handleSetFilledData } = useSimpleProduct();
  const { handleSetDrawerWasClosed } = useRegisterAdded();

  useEffect(() => {
    setBtnDisable(false);
  }, []);

  const handleSetQtdTurno = useCallback(
    (operacao: string) => {
      if (operacao === 'add') {
        if (qtdTurnos.length == 0) {
          setQtdTurnos([
            {
              index: 0,
            },
          ]);

          return;
        }

        setQtdTurnos([
          ...qtdTurnos,
          {
            index: qtdTurnos[qtdTurnos.length - 1].index + 1,
          },
        ]);
      } else if (operacao === 'remove') {
        if (qtdTurnos.length == 1) {
          addToast({
            type: 'info',
            title: 'Neste caso você precisa definir pelo menos um turno.',
          });
          return;
        }

        const turnosStoreds: QtdTurnos[] = qtdTurnos;
        turnosStoreds.pop();

        setQtdTurnos([...turnosStoreds]);
      }
    },
    [qtdTurnos, addToast],
  );

  const handleChangeDay = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const { domingo, segunda, terca, quarta, quinta, sexta, sabado } = days;

      if (value === 'domingo') days.domingo = !domingo;

      if (value === 'segunda') days.segunda = !segunda;

      if (value === 'terca') days.terca = !terca;

      if (value === 'quarta') days.quarta = !quarta;

      if (value === 'quinta') days.quinta = !quinta;

      if (value === 'sexta') days.sexta = !sexta;

      if (value === 'sabado') days.sabado = !sabado;

      setDays(days);
    },
    [days],
  );

  const handleSetDisponibilidade = useCallback((invisible: boolean) => {
    setSempreDisponivel(invisible);
  }, []);

  const handleSubmit = useCallback(
    (data: any) => {
      setBtnDisable(true);
      const keys = Object.entries(data);
      const turnoType: TurnoType[] = [];

      if (sempreDisponivel) {
        createDisponibilidade({
          dias: {
            domingo: true,
            segunda: true,
            terca: true,
            quarta: true,
            quinta: true,
            sexta: true,
            sabado: true,
          },
          turnos: [],
        });
      }

      if (qtdTurnos.length == 0 && !sempreDisponivel) {
        createDisponibilidade({ dias: days, turnos: [] });
      } else if (!sempreDisponivel) {
        for (let i = 0; i < qtdTurnos.length; i += 1) {
          const index = i * 2;

          const inicio = Number(keys[index][1]);
          const fim = Number(keys[index + 1][1]);

          if (inicio > fim) {
            addToast({
              type: 'error',
              title: 'Turno inválido.',
              description: 'O início do turno deve ser maior que o fim',
            });
            setBtnDisable(false);

            return;
          }

          const turnoObjectType: TurnoType = {
            inicio,
            fim,
          };

          turnoType.push(turnoObjectType);
        }
        createDisponibilidade({ dias: days, turnos: [...turnoType] });
      }

      handleSetFilledData(true);
      addToast({
        type: 'success',
        title: 'Produto criado.',
      });
    },
    [
      qtdTurnos,
      createDisponibilidade,
      days,
      sempreDisponivel,
      handleSetFilledData,
      addToast,
    ],
  );

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Disponibilidade</h1>
        <span>
          Defina os momentos em que os clientes poderão comprar este item.
        </span>
      </DrawerTabTitle>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.noPaddingBot}>
            <RadioDisponibilidadeWrapper>
              <form>
                <div>
                  <label htmlFor="no_have">
                    <input
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      checked={sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(true)}
                    />
                    Sempre Disponível
                  </label>
                  <span>
                    O item ficará disponível sempre que o restaurante estiver
                    aberto
                  </span>
                </div>

                <div>
                  <label htmlFor="have">
                    <input
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      checked={!sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(false)}
                    />
                    Disponível em dias e horários específicos
                  </label>
                  <span>Selecione os dias que o item estará disponível</span>
                </div>
              </form>
            </RadioDisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingTop}>
            <DisponibilidadeWrapper isInvisible={sempreDisponivel}>
              <div className="dias">
                <span>Dias da Semana</span>

                <input
                  type="checkbox"
                  id="domingo"
                  name="domingo"
                  value="domingo"
                  onChange={handleChangeDay}
                />
                <label htmlFor="domingo">D</label>

                <input
                  type="checkbox"
                  id="segunda"
                  name="segunda"
                  value="segunda"
                  onChange={handleChangeDay}
                />
                <label htmlFor="segunda">S</label>

                <input
                  type="checkbox"
                  id="terca"
                  name="terca"
                  value="terca"
                  onChange={handleChangeDay}
                />
                <label htmlFor="terca">T</label>

                <input
                  type="checkbox"
                  id="quarta"
                  name="quarta"
                  value="quarta"
                  onChange={handleChangeDay}
                />
                <label htmlFor="quarta">Q</label>

                <input
                  type="checkbox"
                  id="quinta"
                  name="quinta"
                  value="quinta"
                  onChange={handleChangeDay}
                />
                <label htmlFor="quinta">Q</label>

                <input
                  type="checkbox"
                  id="sexta"
                  name="sexta"
                  value="sexta"
                  onChange={handleChangeDay}
                />
                <label htmlFor="sexta">S</label>

                <input
                  type="checkbox"
                  id="sabado"
                  name="sabado"
                  value="sabado"
                  onChange={handleChangeDay}
                />
                <label htmlFor="sabado">S</label>
              </div>

              <div className="turno_wrapper">
                <div className="title_wrapper">
                  <span>Horários</span>
                  <AddButton
                    type="button"
                    onClick={() => handleSetQtdTurno('add')}
                  >
                    + Adicionar Turno
                  </AddButton>
                </div>

                {qtdTurnos.map((item) => (
                  <div className="turnos_wrapper">
                    <div className="turno">
                      <span>{`${item.index + 1}º Turno`}</span>
                      <SelectTurno
                        name={`${item.index}turno_inicio`}
                        placeholder="Selecione"
                        options={schedulesOptions}
                      />
                      <SelectTurno
                        name={`${item.index}turno_fim`}
                        placeholder="Selecione"
                        options={schedulesOptions}
                      />

                      <button
                        type="button"
                        onClick={() => handleSetQtdTurno('remove')}
                      >
                        <BsTrash size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </DisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                disabled={btnDisable}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Disponibilidade;
